import React from 'react';
export function Footer() {
  return <footer className="bg-brown border-t border-offwhite/10 py-8 md:py-12 px-4 md:px-8 text-cream" data-id="element-111">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8 text-center md:text-left" data-id="element-112">
        <div className="max-w-sm" data-id="element-113">
          <h3 className="font-serif text-lg md:text-xl font-bold text-terracotta mb-3 md:mb-4" data-id="element-114">
            💛 DE PAREJA A FAMILIA™
          </h3>
          <p className="font-sans text-xs md:text-sm text-cream/70 leading-relaxed" data-id="element-115">
            El sistema N°1 para parejas en Argentina que esperan un hijo. Porque
            atravesar el embarazo conectados no debería depender de la suerte ni
            de "hablar más" sin saber cómo.
          </p>
        </div>

        <div className="flex flex-col gap-2 font-sans text-xs md:text-sm text-cream/80" data-id="element-116">
          <a href="mailto:contacto@depareja.afamilia.shop" className="hover:text-terracotta transition-colors" data-id="element-117">
            contacto@depareja.afamilia.shop
          </a>
          <a href="#" className="hover:text-terracotta transition-colors" data-id="element-118">
            @depareja.afamilia
          </a>
          <a href="https://depareja.afamilia.shop" className="hover:text-terracotta transition-colors" data-id="element-119">
            depareja.afamilia.shop
          </a>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-8 md:mt-12 pt-6 md:pt-8 border-t border-offwhite/10 text-center font-sans text-[10px] md:text-xs text-cream/50" data-id="element-120">
        © De Pareja a Familia™ 2026 — Todos los derechos reservados.
      </div>
    </footer>;
}